document.addEventListener("DOMContentLoaded", () => {
  const updateLocaleLinks = (codename) => {
    if (!window.basePanelPath) return

    const languageLinks = document.querySelectorAll("a[hreflang]")
    languageLinks.forEach((link) => {
      const lang = link.getAttribute("hreflang")
      if (window.basePanelPath[lang]) {
        const newPath = `${window.basePanelPath[lang]}/${codename}`
        link.href = newPath
      }
    })
  }

  const panelGrid = document.getElementById("panel-grid")
  if (!panelGrid) {
    return
  }

  const panelItems = panelGrid.querySelectorAll(
    ".panels-selector__section__item",
  )
  const panelContainers = document.querySelectorAll(".panel-container")
  let firstClick = true

  panelItems.forEach((item) => {
    item.addEventListener("click", function () {
      // Remove active class from all panel items
      panelItems.forEach((item) =>
        item.classList.remove("panels-selector__section__item--active"),
      )
      // Add active class to the clicked panel item
      this.classList.add("panels-selector__section__item--active")

      // Hide all panel containers
      panelContainers.forEach((container) => (container.style.display = "none"))
      // Show the related panel container
      const panel = this.getAttribute("data-model").toLowerCase()
      const relatedContainer = document.getElementById(
        "panel-" + panel + "-container",
      )
      if (relatedContainer) {
        relatedContainer.style.display = "block"
      }

      if (firstClick) {
        firstClick = false
      } else {
        document
          .getElementById(panel + "-info-icon")
          .scrollIntoView({ behavior: "smooth", block: "center" })
        const url = item.getAttribute("data-url")
        window.history.pushState({}, "", url)
        updateLocaleLinks(panel)
      }
    })
  })

  const anchor = window.location.hash
  const selectedCodename = window.urlCodename || (anchor ? anchor.slice(1) : "")
  if (selectedCodename) {
    const panel = document.querySelector(
      `.panels-selector__section__item[data-model="${selectedCodename}"]`,
    )
    if (panel) {
      firstClick = false
      panel.click()
    }
  } else {
    panelItems[0].click()
  }

  document
    .querySelectorAll(
      ".element-details__configurations__section__options-wrapper__more-options",
    )
    .forEach((moreColors) => {
      moreColors.addEventListener("click", () => {
        const model = moreColors.getAttribute("data-model")
        const rows = document.querySelectorAll(
          '.element-details__configurations__section__options-wrapper__rows__row--next[data-model="' +
            model +
            '"]',
        )
        const moreText = moreColors.querySelector(
          ".element-details__configurations__section__options-wrapper__more-options--more",
        )
        const lessText = moreColors.querySelector(
          ".element-details__configurations__section__options-wrapper__more-options--less",
        )

        rows.forEach((row) => {
          if (row.classList.contains("visible")) {
            row.classList.remove("visible")
            moreText.style.display = "inline"
            lessText.style.display = "none"
          } else {
            row.classList.add("visible")
            moreText.style.display = "none"
            lessText.style.display = "inline"
          }
        })

        document
          .querySelectorAll(
            '.element-details__configurations__section__options-wrapper__rows[data-model="' +
              model +
              '"]',
          )
          .forEach((rows) => {
            if (
              rows.classList.contains(
                "element-details__configurations__section__options-wrapper__rows--hidden-rows",
              )
            ) {
              rows.classList.remove(
                "element-details__configurations__section__options-wrapper__rows--hidden-rows",
              )
            } else {
              rows.classList.add(
                "element-details__configurations__section__options-wrapper__rows--hidden-rows",
              )
            }
          })
      })
    })
})
